import { createFileRoute } from "@tanstack/react-router";

import { floorApi } from "~/api";
import { floorPlanQueries } from "~/features/floor/floor-plan.queries";
import { MaintenancePage } from "~/features/maintenance";
import { requirePagePermission } from "~/helpers/auth/route-permission.helper";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/maintenance/")({
  beforeLoad: ({ context: { permissions }, params: { buildingId }, preload }) => {
    requirePagePermission(permissions, "maintenance", buildingId, preload);
  },
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    const floors = await queryClient.ensureQueryData(floorApi.queries.building(buildingId));
    const firstFloorId = floors[0]?.id;
    if (firstFloorId) {
      await queryClient.ensureQueryData(floorPlanQueries.byId(firstFloorId));
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <MaintenancePage routeId={Route.id} />;
}
